import { lazy } from "react";
import { BiCustomize, BiUser } from "react-icons/bi";
import { GoPackage } from "react-icons/go";
import { IoSettingsOutline, IoSpeedometerOutline } from "react-icons/io5";
import { MdOutlineFeedback } from "react-icons/md";
import { RxPerson } from "react-icons/rx";
import { TbSettingsCog } from "react-icons/tb";

const Login = lazy(() => import("../pages/Login"));
const Dashboard = lazy(() => import("../pages/Dashboard"));
const Packages = lazy(() => import("../pages/Packages"));
const AccountSettings = lazy(() => import("../pages/AccountSettings"));
const Notifications = lazy(() => import("../pages/Notifications"));
const Personality = lazy(() => import("../pages/Personality"));
const Users = lazy(() => import("../pages/Users"));
const Cms = lazy(() => import("../pages/Cms"));
const Testimonials = lazy(() => import("../pages/Testimonials"));
const AddEditPersonality = lazy(() => import("../pages/AddEditPersonality"));
export const routes = [
  {
    path: "/",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Dashboard",
    icon: <IoSpeedometerOutline />,
    element: <Dashboard />,
  },
  {
    path: "/login",
    exact: true,
    protected: false,
    showInSidebar: false,
    element: <Login />,
  },
  {
    path: "/users",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Users",
    icon: <BiUser />,
    element: <Users />,
  },
  {
    path: "/personality",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Personality",
    icon: <RxPerson />,
    element: <Personality />,
  },
  {
    path: "/add-edit-personality",
    exact: true,
    protected: true,
    showInSidebar: false,
    title: "Personality",
    icon: <RxPerson />,
    element: <AddEditPersonality />,
  },
  {
    path: "/packages",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Packages",
    icon: <GoPackage />,
    element: <Packages />,
  },
  {
    path: "/testimonials",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Testimonials",
    icon: <MdOutlineFeedback />,
    element: <Testimonials />,
  },
  {
    path: "/cms",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Cms",
    icon: <BiCustomize />,
    element: <Cms />,
  },
  {
    path: "/account-settings",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Account Settings",
    icon: <IoSettingsOutline />,
    element: <AccountSettings />,
  },
  {
    path: "/notifications",
    exact: true,
    protected: true,
    showInSidebar: false,
    title: "Notifications",
    icon: <IoSpeedometerOutline />,
    element: <Notifications />,
  },
];
